import { useLingui } from '@lingui/react/macro'
import { usePageThumbnailUrl } from 'features/knowledgeDocumentViewer/hooks/usePageThumbnailUrl'

import {
  PageLabel,
  ThumbnailImage,
  ThumbnailImageContainer,
  ThumbnailItemWrapper,
  ThumbnailSkeleton,
} from './pageThumbnailSidebarStyles'

interface PageThumbnailItemProps {
  pageNumber: number
  isActive: boolean
  onClick: (pageNumber: number) => void
  pdfUrl?: string
  allowPdfFallback?: boolean
  totalPages?: number
}

export function PageThumbnailItem({
  pageNumber,
  isActive,
  onClick,
  pdfUrl,
  allowPdfFallback = false,
  totalPages,
}: PageThumbnailItemProps) {
  const { t } = useLingui()
  const { url, isLoading, onImageLoad, onImageError } = usePageThumbnailUrl(
    pageNumber,
    pdfUrl,
    { allowPdfFallback, totalPages }
  )

  return (
    <ThumbnailItemWrapper
      $isActive={isActive}
      onClick={(e) => {
        onClick(pageNumber)
        e.currentTarget.blur()
      }}
      title={t`Go to page ${pageNumber}`}>
      <ThumbnailImageContainer $isActive={isActive}>
        {isLoading || !url ? (
          <ThumbnailSkeleton />
        ) : (
          <ThumbnailImage
            src={url}
            alt={t`Page ${pageNumber}`}
            loading='lazy'
            onLoad={onImageLoad}
            onError={onImageError}
          />
        )}
      </ThumbnailImageContainer>
      <PageLabel $isActive={isActive}>{pageNumber}</PageLabel>
    </ThumbnailItemWrapper>
  )
}
